import { lazy, Suspense, useEffect, useState } from "react";

import { useQueryState } from "@/hooks/use-query-state";

import { useSmartActionsAccess } from "../_hooks/use-smart-actions-access";
import { SMART_ACTION_SHADOW_PARAM } from "./smart-action-shadow-search";

const SmartActionDialog = lazy(() =>
  import("../detail/smart-action-dialog").then((module) => ({
    default: module.SmartActionDialog,
  })),
);

/**
 * The Smart Action popup, mounted once in the office layout, so it opens over
 * any page that holds `?smartActionId=` (the board, an order, Reports → AI
 * feedback) and closes back to that page. Its code loads on the first open,
 * and only for people who may use Smart Actions; once loaded it stays mounted,
 * so closing it animates.
 */
export function SmartActionShadowDialog() {
  const [smartActionId] = useQueryState(SMART_ACTION_SHADOW_PARAM);
  const { allowed } = useSmartActionsAccess();
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (smartActionId) setHasOpened(true);
  }, [smartActionId]);

  if (!allowed || !(hasOpened || smartActionId)) return null;
  return (
    <Suspense fallback={null}>
      <SmartActionDialog />
    </Suspense>
  );
}
